import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "output"]
  static values = { variables: Object }

  connect() {
    this.preview()
  }

  preview() {
    if (!this.hasOutputTarget) return

    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => this.fetchPreview(), 1000)
  }

  async fetchPreview() {
    const template = this.inputTarget.value || ""
    const wrapper = this.outputTarget.closest("[data-url-template-preview-wrapper]")

    if (!template.trim()) {
      this.outputTarget.textContent = ""
      this.outputTarget.removeAttribute("href")
      wrapper?.classList.add("hidden")
      return
    }

    const csrfToken = document.querySelector("meta[name=csrf-token]")?.content
    const response = await fetch("/string_interpolations", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken,
        "Accept": "application/json"
      },
      body: JSON.stringify({ template, variables: this.variablesValue })
    })

    if (!response.ok) return

    const { result } = await response.json()
    this.outputTarget.textContent = result || ""
    this.outputTarget.href = result || ""
    wrapper?.classList.toggle("hidden", !result)
  }
}
